//    Copyright 2020 Siemens
let globalContext = (typeof global == 'undefined')?  window:  global;
if ( globalContext.SPLM === undefined )
{
    let SPLM = {};
    SPLM.get$ID=function(){
      if(SPLM.$m_id === undefined)
        SPLM.$m_id = 0;
      SPLM.$m_id++;
      return '$' +  SPLM.$m_id}
    SPLM.s$=function(data,param,value){
      data[param]=value;
      if(SPLM.api !== undefined){
        var r={};
        r['Class']=data['Class'];
        r['ObjectId']=data['ObjectId'];
        r[param]=data[param];
        SPLM.api.push(r)}}
    SPLM.result$=function(r, clss, $id){
      if(SPLM.api !== undefined){
        SPLM.api.push(r);
        if(clss !== undefined){
          var c=SPLM.new$(clss,{'$var':$id}, false);
          c.result=function() {
             return SPLM.new$(clss,{'$var':$id}, false)};
          return c;
        }else{
          r={'$var':$id};
          r.result=function() {
            return {'$var':$id}};
          return r}
      } else {
        if(clss !== undefined){
          var c=SPLM.new$(clss,r, false);
          c.result=function() {
             return SPLM.new$(clss,{'$var':$id}, false)};
          return c;
        } else {
          r.result=function() {
            return {'$var':$id}};
          return r}}}
    SPLM.p$=function(data,param, clss){
      data[param]={};
      let r={};
      var $id= SPLM.get$ID();
      r[param]=data[param];
      r[param]["%"+param]=$id;
      r['Class']=data['Class'];
      r['ObjectId']=data['ObjectId'];
      return SPLM.result$(r, clss, $id);}
    SPLM.r$=function(data,value,routine,apiResult){
      data[routine]=value;
      let r={};
      let param;
      let clss;
      let resultClss = undefined;
      let resultId = '';
      let o={};
      if(apiResult !== undefined){
        for( var i in apiResult){
          var $id= SPLM.get$ID();
          if(i == 'R_'){
            resultId = $id;
            param=Object.keys(apiResult[i]).toString();
            clss=apiResult[i][param];
            if (clss !== undefined && clss !== '') {
              resultClss = clss;
              o = SPLM.new$(clss,{$var: $id},false);
              o.result = function(){return SPLM.new$(clss,{$var: $id}, false)};
            }
             else{
              o = {$var:$id};
              o.result = function(){return {$var:$id}};
            }
          }
          else{
            clss=apiResult[i];
            param=i;
          if(clss !== undefined && clss !== '')
            o[param] = SPLM.new$(clss,{$var:$id},false);
          else
            o[param] = {$var:$id};  
          }
          data[routine]["%"+ param]=$id}};
      r[routine]=data[routine];
      r['Class']=data['Class'];
      r['ObjectId']=data['ObjectId'];
      if(SPLM.api !== undefined){
        SPLM.api.push(r);
        return o;
      }
      else if(resultId != '') return SPLM.result$(r, resultClss, resultId);
      else return r;} 
    SPLM.op$ = function(obj, param, clss)
    {
     var $id= SPLM.get$ID();
     if(clss !== undefined && clss !== '')
     {
       obj["ObjectId"] = {$var:$id};
     }
     if(SPLM.api !== undefined)
     {
       return $id;
     }
    }
    SPLM.add$property = function(clss, subobject, name, setter, type, deprecated){
        if(clss !== undefined){
            if(Number.isInteger(type))
            {
                deprecated = type;
                type = undefined;
            }
            if(subobject === 1)
            {
                Object.defineProperty(clss.prototype, name,{get: function(){if(this._d[name] === undefined) this._d[name]=SPLM.p$(this._d,name,type); if(deprecated) console.warn(name+" is deprecated"); return this._d[name]},
                                                            set: function(v){throw "Readonly property "+name}})
            }
            else if (setter === 1)
            {
                Object.defineProperty(clss.prototype, name,{get: function(){ if(deprecated) console.warn(name+" is deprecated"); return SPLM.p$(this._d, name,type);},
                                                            set: function(v){ if(deprecated) console.warn(name+" is deprecated"); SPLM.s$(this._d,name,v);}});
            }
            else
            {
                Object.defineProperty(clss.prototype, name,{get: function(){ if(deprecated) console.warn(name+" is deprecated"); return SPLM.p$(this._d, name,type);},
                                                            set: function(v){throw "Readonly property "+name}});
            }
        }
    }
    SPLM.add$contains = function(clss, name, type, deprecated){
        if(clss !== undefined){
            Object.defineProperty(clss.prototype, name, {get: function(){if(this["_"+name] === undefined) this["_" +name] = SPLM.new$(type, this, true);  if(deprecated) console.warn(name+" is deprecated"); return this["_" +name];},
                                                         set: function(v){ if(deprecated) console.warn(name+" is deprecated"); }});
        }
    }
    SPLM.to$Object = function(names, values, numOfInputArgs) {
        var result = {};
        if(names.length < numOfInputArgs)
        {
            console.error("arguments mismatch");
        }
        for (var i = 0; i < numOfInputArgs; i++)
        {
            result[names[i]] = values[i];
        }
        //for out args, create localvar then use it
        for(var i = numOfInputArgs; i < names.length; i++)
        {
            if(typeof values[i] == "object")
            {
                result["%"+names[i]] = SPLM.op$(values[i]._d, names[i], values[i].Class);
            }
        }
        return result;
    }
    SPLM.add$function = function(clss, value,routine,apiResult, numOfInputArgs, deprecated){
        if(clss === undefined){
            return;
        }
        if(value.length == 0){
            clss.prototype[routine] = function(){
                if(deprecated) console.warn(routine+" is deprecated"); return SPLM.r$(this._d, {}, routine, apiResult);
            }
        }
        else{
            clss.prototype[routine] =  function(){
                if(deprecated) console.warn(routine+" is deprecated");
                return SPLM.r$(this._d, SPLM.to$Object(value, arguments, numOfInputArgs), routine, apiResult);
            }
        }
    }
    SPLM.new$ = function(type, arg, throwError){
        let clss = SPLM.get$class(type);
        if(clss !== undefined){
            return new clss(arg)
        }
        if(throwError){throw "class SPLM." + type + " is undefined.";}
        return arg;
    }
    SPLM.get$class = function(type){
        if(typeof type ==='string'){
            let sp = type.split('.');
            let clss = SPLM;
            for(let i = 0; i < sp.length;i++){
                if(clss !== undefined){
                    clss = clss[sp[i]];
                }
            }
            return clss;
        }
        return type;
    }
    SPLM.create$property = function(clss, properties){
        properties.forEach(property =>{
            if(property.length == 5){
                SPLM.add$property(clss, property[0], property[1], property[2], property[3], property[4]);
             }else if(property.length == 4){
                 SPLM.add$property(clss,  property[0], property[1],property[2], property[3]);
             }
             else {
                 SPLM.add$property(clss,  property[0], property[1], property[2]);
            }
        });
    }
    SPLM.create$contain = function(clss, contains){
        contains.forEach(contain =>{
            SPLM.add$contains(clss, contain[0], contain[1], contain[2]);
        });
    }
    SPLM.create$method = function(clss, methods){
        methods.forEach(method =>{
            SPLM.add$function(clss, method[0], method[1], method[2], method[3], method[4]);
        });
    }
    SPLM.c$d = function(clssName, data){
        if(data.length == 3){
           let clss =  SPLM.get$class(clssName.slice(5));
           SPLM.create$property(clss, data[0]);
           SPLM.create$method(clss, data[1]);
           SPLM.create$contain(clss, data[2]);
       }
    }
    SPLM.makeReuse = function(obj, id){
        if (obj instanceof SPLM.TransientObject)
        {
            throw new Error("Object is transient so it cannot be reused")
        }
        if(SPLM.api === undefined &&  obj.ObjectId !== undefined){
            for (var func in obj._d.ObjectId) {
                for (var arg in obj._d.ObjectId[func]) {
                   if(arg.startsWith("%") && !arg.startsWith("%%")){
                       if(id !== undefined){
                           obj._d.ObjectId[func]["%" + arg]= id
                       }
                       else{
                           obj._d.ObjectId[func]["%" + arg]= obj._d.ObjectId[func][arg];
                       }
                       delete obj._d.ObjectId[func][arg];
                       return obj;
                   }
                }
            }
        }
        else if(SPLM.api !== undefined &&
                obj.ObjectId !== undefined &&
                obj.ObjectId.$var !== undefined ){
            for(let i = 0; i < SPLM.api.length; i++){
                for (var func in SPLM.api[i]) {
                    for (var arg in SPLM.api[i][func]) {
                        if(SPLM.api[i][func][arg] == obj.ObjectId.$var){
                            if(id !== undefined){
                                SPLM.api[i][func]["%" + arg]= id;
                                obj.ObjectId.$var = id;
                           }
                           else{
                                SPLM.api[i][func]["%" + arg]= SPLM.api[i][func][arg];
                            }
                            delete SPLM.api[i][func][arg];
                           return obj;
                        }
                    }
                }
            }
        }
        return obj;
    }
    globalContext.SPLM = SPLM;
}
let SPLM = globalContext.SPLM;
export default SPLM;